export default __webpack_public_path__ + "static/media/strong_vendor_network.1e84c93e.png";